import { Controller } from "@hotwired/stimulus";

// Switches Create New Event between its template and scratch panes. Only one
// pane is in the DOM flow at a time, so only one form can be submitted and the
// other's required fields stay out of the way.
//
// Primer's own segmented-control controller owns the selected styling; this
// only reacts to the click.
export default class extends Controller {
  static targets = ["pane"];

  select(event) {
    const item = event.target.closest("[data-mode]");
    if (!item) return;

    this.show(item.dataset.mode);
  }

  show(mode) {
    this.paneTargets.forEach((pane) => {
      pane.hidden = pane.dataset.mode !== mode;
    });
  }
}
